<template>
  <div class="wrapper" @click="close">
    <div class="wrapper-inner">
      <span class="card green" v-if="cardValue == 'Green'"></span>

      <span class="card yellow" v-else-if="cardValue == 'Yellow'"></span>

      <span class="card amber" v-else-if="cardValue == 'Amber'"></span>

      <span class="card purple" v-else-if="cardValue == 'Purple'"></span>

      <span class="card red" v-else-if="cardValue == 'Red'"></span>

      <span class="card" v-else-if="cardValue === 'coffee'">
        <span class="card-image">
          <img src="../assets/coffee.png">
        </span>
      </span>

      <span class="card" v-else>
        <span class="card-text">
          {{ cardValue === 'question'?'?':cardValue==='.5'?'1/2':cardValue }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevealedCard',
  props: { cardValue: { default: '0' } },
  methods: {
    close() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: table;
  margin-left: auto;
  margin-right: auto;
  height: stretch;
}

.wrapper-inner {
  display: table-cell;
  vertical-align: middle;
}

.card {
  display: table;
  height: 300px;
  width: 240px;
  background-color: rebeccapurple;
  color: white;
  border-radius: 30px;
  border: 2px solid white;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.6);
  margin: 0 auto;
}

.green {
  background-color: green;
}

.yellow {
  background-color: yellow;
}

.amber {
  background-color: orange;
}

.purple {
  background-color: purple;
}

.red {
  background-color: red;
}

.card .card-text {
  display: table-cell;
  vertical-align: middle;
  font-size: 128px;
  font-weight: bold;
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.6);
}

.card .card-image {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.card .card-image img {
  height: 180px;
}
</style>
